import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import CTA from '../components/CTA';

const HomePage = () => {
    return (
        <div className="min-h-screen">
            <Header />
            <Hero />
            <Services />
            <CTA />
            <Testimonials />
            <Footer />
        </div>
    );
};

export default HomePage;
